import { useAppSelector } from '@frontend/common';
import { UserClient } from '@frontend/user/api';
import { fetchProfile, updateCurrent, userStore } from '@frontend/user/redux';
import { IUser } from '@frontend/user/types';
import { useCacheBusting } from '@frontend/version/hooks';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavigateFunction, useNavigate } from 'react-router-dom';

import { VERSION } from '../../version';
import { useAppDispatch } from '../redux/store';
import { Props } from './header-component';

interface ViewProps {
    user?: IUser;
    navigate: NavigateFunction;
    updateAvailable: boolean;
    updateApplication: () => void;
    showLanguageSelect: boolean;
    setShowLanguageSelect: (value: boolean) => void;
}

const useHeader = (props: Props): ViewProps => {
    const dispatch = useAppDispatch();
    const { updateAvailable, update } = useCacheBusting({ currentVersion: VERSION, repository: 'admin' });
    const [user, setUser] = useState<IUser | undefined>(undefined);
    const [showLanguageSelect, setShowLanguageSelect] = useState<boolean>(false);
    const navigate = useNavigate();
    const userState = useAppSelector(useSelector, userStore);

    useEffect(() => {
        dispatch(fetchProfile());
    }, []);

    useEffect(() => {
        if (userState.current) setUser(userState.current);
        else {
            UserClient.fetchMyself().then((fetchedUser) => {
                setUser(fetchedUser);
                dispatch(updateCurrent(fetchedUser));
            });
        }
    }, [userState.current]);

    return {
        user,
        navigate,
        updateAvailable,
        updateApplication: update,
        showLanguageSelect,
        setShowLanguageSelect
    };
};

export default useHeader;
